export function allocateAdRegisterSerial(board, request, stayId) {
  const registerId = String(board.adRegisterId || 'legacy');
  if (String(request.registerId || 'legacy') !== registerId)
    throw new Error('A&D register doosre device par badal gaya hai. Check-in form dobara kholein.');
  const mode = request.mode || 'auto';
  if (!['auto', 'manual', 'new_register'].includes(mode)) throw new Error('Invalid A&D serial mode.');
  const previousNext = Number(board.nextAdRegisterSerialNo || Number(board.lastAdRegisterSerialNo || 0) + 1);
  const next = Number.isSafeInteger(previousNext) && previousNext > 0 ? previousNext : 1;
  const text = String(request.value || '').trim();
  let serial = mode === 'auto' ? next : (/^[1-9]\d*$/.test(text) ? Number(text) : NaN);
  if (!Number.isSafeInteger(serial) || serial < 1) throw new Error('A&D serial mein positive whole number likho.');
  const assignments = mode === 'new_register' ? {} : {...(board.adRegisterSerialAssignments || {})};
  const ids = value => (Array.isArray(value) ? value : value ? [value] : []).map(String);
  if (mode !== 'new_register') for (const [number, value] of Object.entries(request.historicalAssignments || {})) {
    const merged = [...new Set([...ids(assignments[number]), ...ids(value)])];
    assignments[number] = merged.length === 1 ? merged[0] : merged;
  }
  if (mode === 'auto') while (ids(assignments[String(serial)]).some(id => id !== stayId)) serial++;
  const duplicateStayIds = ids(assignments[String(serial)]).filter(id => id !== stayId);
  const reuseReason = String(request.reuseReason || '').replace(/\s+/g, ' ').trim();
  if (request.allowReuse === true && (mode !== 'manual' || !reuseReason || reuseReason.length > 200))
    throw new Error('Same serial reuse ke liye manual number aur reason likho (maximum 200 characters).');
  if (duplicateStayIds.length && request.allowReuse !== true)
    throw new Error(`A&D serial ${serial} already use hua hai. Correction ke liye Same serial dobara use karein select karke reason likho.`);
  const linkedIds = [...new Set([...ids(assignments[String(serial)]), stayId])];
  assignments[String(serial)] = linkedIds.length === 1 ? linkedIds[0] : linkedIds;
  const nextSerial = mode === 'new_register' ? serial + 1 : Math.max(next, serial + 1);
  if (!Number.isSafeInteger(nextSerial)) throw new Error('A&D serial number bahut bada hai.');
  return {serial: String(serial), registerId: mode === 'new_register' ? stayId : registerId,
    reusedSerial: duplicateStayIds.length > 0, duplicateStayIds, reuseReason: request.allowReuse === true ? reuseReason : '',
    boardFields: {adRegisterId: mode === 'new_register' ? stayId : registerId,
      adRegisterSerialAssignments: assignments, nextAdRegisterSerialNo: nextSerial,
      lastAdRegisterSerialNo: nextSerial - 1}};
}
